import { apiDiet } from './apiDiet'
import { apiMaterials } from './apiMaterials'
import { apiAllergens } from './apiAllergens'
import { apiSemiProducts } from './apiSemiProducts'
import { apiMeals } from './apiMeals'
import { apiMealpreps } from './apiMealpreps'
import { apiMealPackaging } from './apiMealPackaging'
import { apiNutritionalParameters } from './apiNutritionalParameters'
import { apiFoodProductionStage } from './apiFoodProductionStage'
import { apiDietComponents } from './apiDietComponents'
import { apiMealSizes } from './apiMealSize'
import { apiMealVariant } from './apiMealVariant'
import { apiDietTags } from './apiTags'

import { apiDietDays } from './apiDietDays'
import { apiDietAddons } from './apiAddons'
import { apiSizeMatrices } from './apiSizeMatrices'

const apiDiets = {
	...apiDiet,
	...apiMaterials,
	...apiAllergens,
	...apiSemiProducts,
	...apiMeals,
	...apiMealpreps,
	...apiFoodProductionStage,
	...apiDietComponents,
	...apiMealPackaging,
	...apiNutritionalParameters,
	...apiMealSizes,
	...apiMealVariant,
	...apiDietTags,
	...apiDietDays,
	...apiDietAddons,
	...apiSizeMatrices,
}

export { apiDiets }
